import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

class BuyBar {
	constructor() {
		// this.productSection = document.querySelector('.product');
		this.mainBuyButton = document.querySelector('.product .product__add-btn')
		this.bar = document.querySelector('.buy-bar');
	}

	init() {
		if (!this.mainBuyButton || !this.bar) return;

		this.watchScroll();
	};

	watchScroll() {
		ScrollTrigger.create({
			trigger: this.mainBuyButton,
			start: 'top bottom-=100px',
			end: 'bottom top+=110px',
			toggleClass: {
				targets: this.bar,
				className: 'is-hidden'
			},
			// onToggle: self => console.log("toggled to active:", self.isActive)
			// onUpdate: ({ progress }) => {
			// 	console.log((progress * 100).toFixed(1) + '%');
			// }
		});
	}
}

window.addEventListener('product-purchase:mounted', (e) => {
	new BuyBar().init();
});
